<template>
  <v-layout>
      <v-flex xs12 sm12>
        <v-card>
          <v-card-title style="font-size: 2em; font-family: 'hk-grotesk';">{{ $t('key329') }} {{ this.$store.state.userdata.displayname }}</v-card-title>
          <v-form v-model="valid">
            <v-card-text>
              <v-flex sm12>
                <p>{{ $t('key333') }}.</p>
              </v-flex>
            </v-card-text>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
</template>

<script>
export default {
  data() {
    return {
      message: ""
    };
  },
  created(){
    this.$store.dispatch("ImpostaScollegamento");
  },
  mounted() {
    this.$store.dispatch("getCappario");
    //var test = localStorage.getItem('cappario');
    //console.log(this.$store.state.cappario);
  },
  methods: {
    
  }
};
</script>